// External URLs used across the landing
export const EXTERNAL = {
  AUTH_URL: 'https://primevision.app/auth',
  SURVEY_URL:
    'https://docs.google.com/forms/d/e/1FAIpQLSdbSoi3pU0B44maJMS4-_IDsevVKLmtsMAjCJuvDWI8u2af7A/viewform',
  SITE_URL: 'https://www.primevision.app',
  INSTAGRAM_URL: 'https://www.instagram.com/primevisionsoftware/',
  FACEBOOK_URL: 'https://www.facebook.com/profile.php?id=61586161545013',
};

export const BRAND = {
  name: 'Prime Vision',
  tagline_it: 'Più visione clinica. Meno burocrazia.',
  tagline_en: 'More clinical vision. Less paperwork.',
  email: 'info@primevision.it',
  logo: '/assets/prime-vision-logo.png',
};
